import GenericRequest, { METHOD_GET } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import RouterUtils from '../../shared/routing/RouterUtils';

export default class TypeDocumentRequest extends GenericRequest {

    constructor(id) {
        super(METHOD_GET, RouterUtils.generateRoute(ApiEndpoints.DOCUMENT_TYPE_ID, { id: id }));
    }

}



// WEBPACK FOOTER //
// ./src/app/documents/ws/TypeDocumentRequest.js